import { AxiosError } from 'axios'
import * as Sentry from '@sentry/react'
import { store } from '../../../../state/configure_store'
import { logout } from '../../../../state/actions/constants'
import { notifyErrorBoundary } from '../../../../events/errorEventEmitter'

const dispatch = store.dispatch

type IError = {
  message?: string
  error?: string
}

export const responseErrorInterceptor = (error: AxiosError<IError>) => {
  const statusCode = error.response?.status || 0
  const config = error.config
  const method = config?.method || 'UNKNOWN_METHOD'
  const apiUrl = config?.url || 'UNKNOWN_URL'

  let params = config?.data

  try {
    params = typeof config?.data === 'string' ? config.data : JSON.stringify(config?.data)
  } catch {
    params = 'Unserializable params'
  }

  let customMessage = error.message

  if (error.response?.data) {
    if (typeof error.response.data === 'string') {
      customMessage = error.response.data // If API returns a plain string
    } else if (error.response.data.message) {
      customMessage = error.response.data.message // If API returns { message: "Error details" }
    } else if (error.response.data.error) {
      customMessage = error.response.data.error // If API returns { error: "Some error" }
    }
  }

  // Unauthorized: Logout
  if (dispatch && statusCode === 403 && customMessage.includes('Uw sessie is verlopen.')) {
    dispatch(logout())
  }

  Sentry.captureException(error, {
    extra: {
      method,
      url: apiUrl,
      params,
      message: customMessage
    }
  })

  // Send error to UI which will be thrown by error provider
  notifyErrorBoundary(new Error(customMessage))

  return Promise.reject(
    new AxiosError(customMessage, error.code, config, error.request, error.response)
  )
}
